import React from 'react'
import Modal from 'modal-enhanced-react-native-web'

export default ({ visible, onClose, backDropAction, children, ...rest }) =>
  <Modal isVisible={visible} onBackdropPress={() => backDropAction && onClose()} onBackButtonPress={onClose} {...rest}>
    {children}
  </Modal>

